import { css } from '@fable/theme'
import { AnimatePresence, motion } from 'framer-motion'
import { useStatsTheme } from '../../../ctx'

interface Props {
  top?: string
  middle?: string
  bottom?: string
  topAlt?: string
  bg?: {
    start: string
    end?: string
  }
}

export const SectionBlur = ({ top, topAlt, middle, bottom, bg }: Props) => {
  const currentTheme = useStatsTheme((s) => s.currentTheme)

  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      `}
    >
      <AnimatePresence>
        {bg ? (
          <motion.span
            layout
            key={currentTheme}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className={css`
              display: block;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                180deg,
                ${bg.start} 0%,
                ${bg.end || 'rgba(255, 255, 255, 0)'} 100%
              );
              position: absolute;
              top: 0;
              left: 0;
              will-change: opacity, transform;
              pointer-events: none;
            `}
          />
        ) : null}
      </AnimatePresence>
      <span
        className={css`
          display: block;
          width: 200%;
          height: 500px;
          position: absolute;
          top: 530px;
          left: 0;
          border-radius: 100%;
          background-color: ${bottom || 'transparent'};
          filter: blur(60px);
          z-index: 1;
          transition: background-color ease-in-out 0.6s;
          will-change: background-color;
        `}
      />
      <span
        className={css`
          display: block;
          width: 110%;
          height: 350px;
          position: absolute;
          top: 150px;
          right: -40%;
          border-radius: 100%;
          background-color: ${middle || 'transparent'};
          transform: rotate(55deg);
          filter: blur(60px);
          z-index: 2;
          transition: background-color ease-in-out 0.6s;
          will-change: background-color;
        `}
      />
      <span
        className={css`
          display: block;
          width: 100%;
          height: 300px;
          position: absolute;
          top: -100px;
          left: -50%;
          border-radius: 100%;
          background-color: ${topAlt || 'transparent'};
          filter: blur(60px);
          z-index: 3;
          transition: background-color ease-in-out 0.6s;
          will-change: background-color;
        `}
      />
      <span
        className={css`
          display: block;
          width: 250%;
          height: 600px;
          position: absolute;
          top: -200px;
          left: -5%;
          border-radius: 100%;
          background-color: ${top || 'transparent'};
          filter: blur(60px);
          z-index: 4;
          transition: background-color ease-in-out 0.6s;
          will-change: background-color;
        `}
      />
    </div>
  )
}
